import React, {Component} from 'react';
import StringUtil from "../../utils/StringUtil";
import {TextInput, Wizard} from "../../components";
import RemotingService from "../../services/remoting-service/RemotingService";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import SignatureInput from "../../components/signature-input/SignatureInput";
import Logo from "../../layout/DiscLogo";
import FormField from "../../components/form/FormField";
import PatientUtil from "../../utils/PatientUtil";
import DateUtil from "../../utils/DateUtil";
import NabidhFormTextEnum from "./NabidhFormTextEnum";
import FormLanguages from "./enum/FormLanguages";
import moment from "moment/moment";
import {isMinor} from '../patient/Patient';

class NabidhConsentForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            patientDate: new Date(),
            consentAction: null
        }

        this.formFields = [];
    }

    handleConsentActionChange = (value) => {
        this.setState({
            consentAction: value
        });
    };

    onSubmit = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        if (this.props.form !== null && this.props.form !== undefined) {
            this.props.close();
        } else {
            const patient = this.props.patient;
            const patientFullName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
            const patientMrn = StringUtil.mrn(patient.mrn);
            const patientDOB = patient.birthday;

            const {
                consentAction, patientSignature, witnessName, witnessSignature, relationshipToPatient
            } = this.state;

            RemotingService.postRemoteCall(`api/patient/${this.props.patient.id}/nabidh-consent-form`,
                {
                    // patientDate is set automatically by the backend for audit purposes
                    consentType: consentAction,
                    patientSignature,
                    witnessName,
                    witnessSignature,
                    relationshipToPatient,
                    patientFullName,
                    patientMrn,
                    patientDOB
                },
                (result) => {
                    this.props.afterSave(result);
                    this.props.close();
                });
        }
    }

    onSaveWitnessSignature = (signature) => {
        this.setState({witnessSignature: signature})
    }

    onSavePatientSignature = (signature) => {
        this.setState({patientSignature: signature})
    }

    getLocalizedText(key) {
        const selectedLanguage = this.props.selectedLanguage || FormLanguages.ENGLISH;
        const textEnum = NabidhFormTextEnum;
        return textEnum[key] ? textEnum[key][selectedLanguage.name] : '';
    }

    getConsentActionFromForm(form) {
        return form.consentType || null;
    }

    render() {
        if (!this.props.show)
            return null;

        let {patient, form} = this.props;
        let readOnly = form !== null && form !== undefined;
        let mrnNo = StringUtil.mrn(patient.mrn);
        let patientName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
        this.formFields = [];
        const selectedLanguage = this.props.selectedLanguage || FormLanguages.ENGLISH;
        const isPatientMinor = isMinor(patient.birthday, 'UAE');
        const isArabic = selectedLanguage.name === 'Arabic';
        const textDirection = isArabic ? 'rtl' : 'ltr';
        const textAlign = isArabic ? 'right' : 'left';

        return (
            <Wizard
                show={this.props.show}
                close={this.props.close}
                title={this.getLocalizedText('Nabidh_Consent_Form_Header')}
                onSubmit={this.onSubmit}
                isReadOnly={readOnly}
            >
                {/* Page 1: Header and Consent Acknowledgment */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{width: '1000px'}}>
                        <div style={{
                            marginTop: '15px', marginBottom: '15px', width: '100%', display: 'flex',
                            flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'
                        }}>
                            <Logo/>
                            <div>
                                <h2>{this.getLocalizedText('Nabidh_Consent_Form_Title')}</h2>
                            </div>
                        </div>

                        <hr style={{
                            borderTop: "2px solid #000000",
                            marginTop: "-10px",
                            boxShadow: "0px 2px 2px #797979"
                        }}/>

                        {/* Patient Information */}
                        <div style={{border: "1px solid #000000"}}>
                            <div style={{margin: "15px 15px"}}>
                                <h5>{this.getLocalizedText('Patient_Information')}</h5>
                                <div className={"row"} style={{marginTop: "10px", marginLeft: "0px"}}>
                                    <div className="col-md-5">
                                        <b>{this.getLocalizedText('Name')}</b> {patientName}
                                    </div>
                                    <div className="col-md-4">
                                        <b>{this.getLocalizedText('MRN')}</b> {mrnNo}
                                    </div>
                                    <div className="col-md-3">
                                        <b>{this.getLocalizedText('DOB')}</b> {DateUtil.formatDate(patient.birthday)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Consent Acknowledgment Header */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit', fontWeight: 'bold'}}>
                                    {this.getLocalizedText('Consent_Acknowledgment_Header')}
                                </p>
                            </div>
                        </div>

                        {/* Consent Statement 1 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_1')}
                                </p>
                            </div>
                        </div>

                        {/* Consent Statement 2 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_2')}
                                </p>
                            </div>
                        </div>

                        {/* Consent Statement 3 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_3')}
                                </p>
                            </div>
                        </div>

                        {/* Consent Statement 4 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_4')}
                                </p>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 2: Remaining Consent Statements and Options */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{width: '1000px'}}>
                        {/* Consent Statement 5 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_5')}
                                </p>
                            </div>
                        </div>

                        {/* Consent Statement 6 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_6')}
                                </p>
                            </div>
                        </div>

                        {/* Consent Statement 7 */}
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Consent_Statement_7')}
                                </p>
                            </div>
                        </div>

                        {/* Date Field */}
                        <div className={"container"}>
                            <div className={"row"} style={{marginTop: "10px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Date')}
                                </div>
                                <div className="col-md-3">
                                    {readOnly && form.patientDate ?
                                        moment(new Date(form.patientDate)).format('MMMM DD, YYYY')
                                        :
                                        moment(new Date(this.state.patientDate)).format('MMMM DD, YYYY')
                                    }
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Patient_Name')}
                                </div>
                                <div className="col-md-9">
                                    {patientName}
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Patient_Signature')}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                               disabled={readOnly}
                                               required requiredMessage={this.getLocalizedText('Signature_Required')}
                                               validateOn={this.state.patientSignature}>
                                        <SignatureInput
                                            signature={readOnly ? form.patientSignature : this.state.patientSignature}
                                            onSave={this.onSavePatientSignature} readOnly={readOnly}/>
                                    </FormField>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                {/* Page 3: Guardian/Witness Section */}
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{width: '1000px'}}>
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px", direction: textDirection, textAlign: textAlign}}>
                                <p style={{fontSize: isArabic ? '18px' : 'inherit'}}>
                                    {this.getLocalizedText('Guardian_Section_Header')}
                                </p>
                            </div>
                        </div>

                        <div className="container">
                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Parent_Guardian_Name')}
                                </div>
                                <div className="col-md-9 dim14-base-input">
                                    <TextInput value={readOnly ? form.witnessName : this.state.witnessName}
                                               disabled={readOnly} alphabeticOnly style={{textAlign: "center"}}
                                               onChange={(val) => this.setState({witnessName: val})}/>
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Guardian_Relationship')}
                                </div>
                                <div className="col-md-9 dim14-base-input">
                                    <TextInput value={readOnly ? form.relationshipToPatient : this.state.relationshipToPatient}
                                               disabled={readOnly} alphabeticOnly style={{textAlign: "center"}}
                                               onChange={(val) => this.setState({relationshipToPatient: val})}/>
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Witness_Signature')}
                                </div>
                                <div className="col-md-9">
                                    <SignatureInput
                                        signature={readOnly ? form.witnessSignature : this.state.witnessSignature}
                                        onSave={this.onSaveWitnessSignature} readOnly={readOnly}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}

export default NabidhConsentForm;
